import Row from '@components/Row';
import Text from '@components/Text';
import { ReactNode } from 'react';

import styles from './styles.module.scss';

export interface LabelValue {
    value: string;
    label?: string;
    trailing?: ReactNode;
}

interface Props {
    data: LabelValue;
    value?: string;
    onChange?: (v: string) => void;
}

function RadioButtonRow({ data, onChange, value }: Props) {
    const { label, trailing } = data;
    const selected = value === data.value;
    return (<Row fullWidth
        data-selected={selected}
        justify='space-between'
        align='center'
        className={styles.container}
        onClick={() => onChange?.(data.value)} >
        <Row spacing={8}>
            <div className={`${styles.circleWrapper} ${selected && styles.selected}`}>
                <div className={styles.circle} >
                    <div className={styles.dot} />
                </div>
            </div>
            <Text>{label ?? data.value}</Text>
        </Row>
        {trailing && (
            <Text>{trailing}</Text>
        )}
    </Row>);
}

export default RadioButtonRow;
